import "./stylesheets/index.sass"

require("./output/Main").main()
